import React from 'react';
import { useIntl } from 'react-intl';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function FormHeader(props) {
  const {
    onClose = () => {}, procedure = '', title = '', titleFull = '', currentApplication, isEdit,
  } = props;
  const { formatMessage } = useIntl();
  return (
    <div className="information-form-header">
      <div className="breadcrumbs">
        <span className="breadcrumbs-prev">Создание документа</span>
        <Icons width={22} height={22} customIcon icon="arrow-right" className="breadcrumbs-arrow" />
        <span className="breadcrumbs-current">{formatMessage({
          id: `in_request_inf.type.${procedure}`,
          defaultMessage: ' ',
        })}
        </span>
      </div>
      <div className="close-button" onClick={onClose}>
        <Icons width={24} height={24} customIcon icon="close" />
      </div>
    </div>
  );
}
